import { Fragment } from 'react';
import styled from 'styled-components';
import getColours from '@lendi-ui/commons/colours';
import Modal from '@lendi-ui/modal';
import { pt } from '@lendi-ui/spacing';

import { Heading, Link } from '@funnels/ui-components';
import { getBrandSpecificBaseURL } from '@funnels/utils';

interface UrlsProps {
  isVisible: boolean;
  onHide: () => void;
}

const ModalWrapper = styled(Modal)`
  > div:nth-of-type(2) {
    ${pt('sm')};
  }
`;

function Urls(props: UrlsProps) {
  const configs = (window as any).funnelsConfigs;

  if (!configs) {
    return null;
  }

  const { FunnelOneConfig, FunnelTwoConfig } = configs;
  const funnels: any = { FunnelOneConfig, FunnelTwoConfig };

  return (
    <ModalWrapper size="lg" isVisible={props.isVisible} onHide={props.onHide}>
      <Modal.Header title="Funnel Urls" />
      <Modal.Content>
        {Object.keys(funnels).map((funnelKey, i: number) => {
          const funnel = funnels[funnelKey];

          return (
            <Fragment key={`url-${i}`}>
              <Heading size="xs">{funnelKey}</Heading>
              {Object.keys(funnel).map((pathKey, j: number) => {
                const path = funnel[pathKey];

                return (
                  <Fragment key={`url-${i}-${j}`}>
                    <Heading size="xxs">{pathKey}</Heading>
                    <ul>
                      {path.questions.map((question: any, k: number) => {
                        const url = `${getBrandSpecificBaseURL()}${question.url}`;

                        return (
                          <li key={`url-${i}-${j}-${k}`}>
                            <Link size="xs" href={url} color={getColours('interaction', 'main')}>
                              {url}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </Fragment>
                );
              })}
            </Fragment>
          );
        })}
      </Modal.Content>
    </ModalWrapper>
  );
}

export default Urls;
